import { useEffect } from "react";
import { useRouteError } from "react-router";

import ErrorOutlineOutlined from "@mui/icons-material/ErrorOutlineOutlined";
import EmptyCard from "components/Cards/EmptyCard";
import WorkspaceHeader from "components/Workspaces/WorkspaceHeader";

export default function ErrorPanel({ title }) {
  let error = useRouteError();

  useEffect(() => {
    console.warn("Error handled in ErrorPanel", error);
  }, [error]);

  return (
    <>
      <WorkspaceHeader title={title || "Error"} />

      <EmptyCard
        text="An error has occurred"
        secondaryText="Please contact customer support or try again later."
        icon={<ErrorOutlineOutlined color="error" fontSize="large" />}
      />
    </>
  );
}
